import ali from "../assets/images/IMG_20190107_210925.jpg";
import fast from "../assets/images/fast-logo.png";
import ids from "../assets/images/ids-logo.png";
import getNotified from "../assets/images/get-notified-logo.png";
import herobg from "../assets/images/herobg.png";

const images = {
    ali,
    fast,
    ids,
    getNotified,
    herobg,
};

export default images;
